import { combineReducers } from 'redux';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { alertReducer } from './alert/reducers'
import { dahsboardReducer } from './dashbord/reducers'
import { reducer } from './employee/actions';

const rootReducers = combineReducers({
  auth: authReducer,
  ChangeLayoutMode,
  alert: alertReducer,
  dashboard: dahsboardReducer,
  newReducer: reducer
});

export default rootReducers;
